import { httpMessage } from "@saleshub/dictionary/http";
import { z } from "zod";
const PHONE_ISO_PATTERN = /^[A-Z]+$/;
const PHONE_CODE_PATTERN = /^[+\d]+$/;
const PHONE_NUMBER_PATTERN = /^\d+$/;
export const phoneSchema = z.object({
    iso: z
        .string({
        required_error: httpMessage.responses.phones.required.iso,
        invalid_type_error: httpMessage.responses.phones.invalid.iso,
    })
        .refine((value) => PHONE_ISO_PATTERN.test(value), {
        message: httpMessage.responses.phones.invalid.iso,
    }),
    code: z
        .string({
        required_error: httpMessage.responses.phones.required.code,
        invalid_type_error: httpMessage.responses.phones.invalid.code,
    })
        .refine((value) => PHONE_CODE_PATTERN.test(value), {
        message: httpMessage.responses.phones.invalid.code,
    }),
    number: z
        .string({
        required_error: httpMessage.responses.phones.required.number,
        invalid_type_error: httpMessage.responses.phones.invalid.number,
    })
        .refine((value) => PHONE_NUMBER_PATTERN.test(value), {
        message: httpMessage.responses.phones.invalid.number,
    }),
});
